import React from "react";
import { connect } from 'react-redux';
import { withLastLocation } from "react-router-last-location";

import { trackEvent } from '../../../../helpers/analyticsHelper';
import { fetchBillAnalysisData } from '../../../../dataFetchers/insightsPageDataFetcher';
import { changeBillAnalysisData } from '../../../../actions/insightsBillAnalysisActions';
import { getBECompatibleFuelType } from '../../../../helpers/helper';


import { PAGE_EVENT_NAMES, FUEL_TYPE, INSIGHTS_PAGES, ARROWS } from '../../../../constants/common';

import InsightsBillAnalysis from "./InsightsBillAnalysis";

class InsightsBillAnalysisContainer extends React.Component {
    componentDidMount() {
        if ( !(this.props.insightsBillAnalysisData.compareBillStart && this.props.insightsBillAnalysisData.billStart) ) {
            this.fetchBillAnalysisData();
        }

        //call analytics function to save viewed event
        trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.INSIGHTS, {
            viewed: true,
            dashboardView: this.props.configs.data['fuelType'],
            shown: INSIGHTS_PAGES.BILL_ANALYSIS
        }, this.props)
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.insightsBillAnalysisData.billStart && prevProps.insightsBillAnalysisData.compareBillStart) && (this.props.insightsBillAnalysisData.billStart !== prevProps.insightsBillAnalysisData.billStart || this.props.insightsBillAnalysisData.compareBillStart !== prevProps.insightsBillAnalysisData.compareBillStart)) {
            this.fetchBillAnalysisData();
        }
    }

    fetchBillAnalysisData() {
        let params = {
            "measurement-type": getBECompatibleFuelType(this.props.configs.data['fuelType']),
            "date-format":  this.props.configs.data["date_format"]
        };

        if (this.props.insightsBillAnalysisData.billStart) {
            params["bill-start"] = this.props.insightsBillAnalysisData.billStart;
        }
        if (this.props.insightsBillAnalysisData.compareBillStart) {
            params["compare-bill-start"] = this.props.insightsBillAnalysisData.compareBillStart;
        }

        this.props.fetchBillAnalysisData(params, this.props.userIdentityDetails.userId);
    }

    changeDataToShowOffset(value) {
        //call analytics function to save arrow click event
        trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.INSIGHTS, {
            dashboardView: FUEL_TYPE.ELECTRIC,
            shown: INSIGHTS_PAGES.BILL_ANALYSIS,
            usageArrowCicked: value === 1 ? ARROWS.LEFT : ARROWS.RIGHT,
            intervalStart: this.props.insightsBillAnalysisData.compareBillStart,
            intervalEnd: this.props.insightsBillAnalysisData.billStart,
        });

        let billStart, compareBillStart;
        if (value === 1) {
            billStart = this.props.insightsBillAnalysisData.compareBillStart;
            compareBillStart = 0;
        } else {
            billStart = 0;
            compareBillStart = this.props.insightsBillAnalysisData.billStart
        }

        this.props.changeBillAnalysisData({
            billStart: billStart,
            compareBillStart: compareBillStart,
            isBillAnalysisLoading: true
        }, () => this.fetchBillAnalysisData());
    }

    render() {
        return (
            <InsightsBillAnalysis insightsBillAnalysisData={this.props.insightsBillAnalysisData} userIdentityDetail={this.props.userIdentityDetails} 
                changeDataToShowOffset={(value) => this.changeDataToShowOffset(value)} electricCostUnit={this.props.configs.data.electric_cost_unit} 
                electricEnergyUnit={this.props.configs.data.electric_energy_unit} gasCostUnit={this.props.configs.data.gas_cost_unit} 
                gasEnergyUnit={this.props.configs.data.gas_energy_unit} translations={this.props.translations.data} />
        )
    }
}

const mapStateToProps = state => {
    return {
        insightsBillAnalysisData: state.insightsBillAnalysisData,
        userIdentityDetails: state.userIdentityDetails,
        configs: state.configs,
        translations: state.translationsData,
        queryParams: state.queryParams
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchBillAnalysisData: (options, userId) => { dispatch(fetchBillAnalysisData(options, userId)) },
        changeBillAnalysisData: (options) => { dispatch(changeBillAnalysisData(options)) }
    }
}

export default withLastLocation(connect(mapStateToProps, mapDispatchToProps)(InsightsBillAnalysisContainer));
